import { Element } from "@api/models/Element";
import { DateTime, Interval } from "luxon";
import { secondsBeforeMoment } from "@common/webinarHelper";
import { Status } from "./Status";

export const getCurrentStatus = (session: Element, isWebConf: boolean) => {

    const secondsBeforeEnd = Math.round(secondsBeforeMoment(session.endAt));

    //ENDED:
    if ((secondsBeforeEnd <= 0 || session.isClosed) && (session.isStarted || !session.isStarted || session.isClosed)) {
        return Status.ended;
    }

    //ENDSOON:
    if (secondsBeforeEnd < 60 * 5 && session.isStarted) {
        return Status.endSoon;
    }

    const now = DateTime.local();

    //STARTED:
    if (session.beginAt <= now && session.endAt >= now || session.isStarted) {
        //если провайдер webconf то не начинать пока сессия не будет isStarted
        return session.isStarted ? Status.started : isWebConf ? Status.notStarted : Status.started;
    }

    const secondsBeforeBegin = Math.round(secondsBeforeMoment(session.beginAt));

    //BEGINSOON:
    if (secondsBeforeBegin > 0 || !session.isStarted) {
        return Status.beginSoon
    }

    return Status.empty;
}

const getTimeFormat = (interval: Interval) => {
    return Math.floor(interval.toDuration(['hours']).toObject().hours || 0) > 0 ? "hh:mm:ss" : "mm:ss";
}

/**
 *
 * @param timeMoment any moment
 * @param fromNow count time from the current moment
 * @returns
 */
export const getTimeString = (timeMoment: DateTime | null, fromNow = true) => {
    const now = DateTime.local();

    if (timeMoment) {
        const interval = fromNow ? Interval.fromDateTimes(now, timeMoment) : Interval.fromDateTimes(timeMoment, now);

        const format = getTimeFormat(interval);
        const duration = interval.toDuration();

        return duration.isValid ? `${interval.toDuration().toFormat(format)}` : '00:00';
    }

    return '00:00';
}